/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const HeaderStyle: any = {
  boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
  backgroundColor: 'rgba(255,255,255, 0.4)',
};

export const AccordionStyle: any = {
  backgroundColor: 'rgba(255,255,255, 0.4)',
};
